import { Accordion, DateTime, IconName, Info as InfoComponent, SymbolBadge } from 'ui/components'
import { Hr } from 'ui/components/Hr'
import { InfoProps } from 'ui/components/Info/Info/InfoProps'
import { Col, Row } from 'ui/themes/globalStyles'
import { CRBIdLicenseDetails } from '~bank-crb-monitor/types'

import { useCRBIdLicenseContext } from '../../CRBIdLicenseContext'

const Info = (props: InfoProps) => <InfoComponent withoutPaddingBottom {...props} />

const StatusLabel = ({ statusMark, status }: Pick<CRBIdLicenseDetails, 'statusMark' | 'status'>) => (
  <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
    {statusMark === 'ok' ? (
      <SymbolBadge color="positive" icon={IconName.CHECK_ROUND} />
    ) : (
      <SymbolBadge color="error" icon={IconName.CROSS_ROUND} />
    )}
    {status}
  </div>
)

export const Details = () => {
  const { data } = useCRBIdLicenseContext()

  const {
    businesses,
    crbmId,
    medRecClassification,
    licensingAuthorityName,
    locality,
    uniformTypeDescription,
    status,
    reportedTypeDescription,
    statusDate,
    previousStatus,
    reportedStatus,
    connectedAt,
    statusLastCheckedAt,
    statusMark
  } = data

  return (
    <Accordion
      title="Details"
      bottomPadding="small"
      actions={<StatusLabel statusMark={statusMark} status={status} />}
      children={
        <>
          <Info label="Businesses">{businesses}</Info>
          <Hr thin />
          <Row>
            <Col>
              <Info label="CRBM ID">{crbmId}</Info>{' '}
            </Col>
            <Col>
              <Info label="Med/Rec/Hemp">{medRecClassification}</Info>{' '}
            </Col>
          </Row>
          <Hr thin />
          <Info label="Licensing Authority">{licensingAuthorityName}</Info>
          <Hr thin />
          <Info label="Locality">{locality}</Info>
          <Hr thin />
          <Row>
            <Col>
              <Info label="Uniform Type">{uniformTypeDescription}</Info>
            </Col>
            <Col>
              <Info label="Uniform Status">
                <StatusLabel statusMark={statusMark} status={status} />
              </Info>
            </Col>
          </Row>
          <Hr thin />
          <Row>
            <Col>
              <Info label="Reported Type">{reportedTypeDescription}</Info>
            </Col>
            <Col>
              <Info label="Reported Status">{reportedStatus}</Info>
            </Col>
          </Row>
          <Hr thin />
          <Row>
            <Col>
              <Info label="Status As Of">
                <DateTime date={statusDate} />
              </Info>
            </Col>
            <Col>
              <Info label="Previous Status">{previousStatus}</Info>
            </Col>
          </Row>
          <Hr thin />
          <Row>
            <Col>
              <Info label="Connected At">
                <DateTime date={connectedAt} withTime />
              </Info>
            </Col>
            <Col>
              <Info label="Last Check">
                <DateTime date={statusLastCheckedAt} withTime />
              </Info>
            </Col>
          </Row>
        </>
      }
    />
  )
}
